import Vue from "vue";

Vue.filter("terminaleStatusName", function(value: number) {
  {
    switch (value) {
      case 0:
        return Vue.$locale.getTranslate('allGood');
      case 1:
        return Vue.$locale.getTranslate('Map_legend_noConnection');
      case 2:
          return Vue.$locale.getTranslate('Map_legend_technicalError');
      case 3:
        return Vue.$locale.getTranslate('Map_legend_collectionRequired');
      case 4:
        return Vue.$locale.getTranslate('Map_legend_setNewPoint');
      case 5:
        return Vue.$locale.getTranslate('Map_legend_negativeBalans');
       
    }
  }
});

/**	NettoCheck = 1,
	NettoCash = 2,
	Bank = 3,
	ATM = 4,
	Shop = 5,
	MobilStore = 6,
	PaymentSystem = 7,
	RunPayMini = 8,
	RunPayXL = 9,
  RunPayWeb = 10 */
  
  /**
   * // <summary>
        /// Все хорошо
        /// </summary>
        Success = 0,
        /// <summary>
        /// Техническая проблема
        /// </summary>
        TechnicalProblem = 1,
        /// <summary>
        /// Нет связи
        /// </summary>
        NoConnection = 2,
        /// <summary>
        /// Требуется инкосация или сбор кеша
        /// </summary>
        CashCollection = 3,
        /// <summary>
        /// Установка новой точки
        /// </summary>
        Install = 4,
        /// <summary>
        /// Отрицательный доступный баланс 
        /// </summary>
        NegativeAvailableBalance = 5
   */


// WEBPACK FOOTER //
// ./scripts/filters/terminaleStatusName.ts